import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Tab } from '@/components/Tabs/Tab';
import { Tabs } from '@/components/Tabs/Tabs';
import { TabsNavigation } from '@/components/Tabs/TabsNavigation';
import { H2 } from '@/components/Typography/Typography';
import { Close } from '@/components/ui/Close/Close';

import { WavesBackground } from '../Backgrounds/WavesBackground/WavesBackground';
import { ModalContext } from '../Modal/config';

import { RevenueTierDatail } from './RevenueTierDetail';

const RevenueDetailsModal: FC = () => {
  const { closeModal } = useContext(ModalContext);
  const { t } = useTranslation();

  const tierList = [
    { id: '1', label: 'Tier 1' },
    { id: '2', label: 'Tier 2' },
  ];

  return (
    <div className="w-full  relative">
      <WavesBackground />
      <Close
        className="absolute top-4 right-4"
        onClick={closeModal}
        variant="modal"
        imageVariant="modal"
      />
      <div className="w-full pt-[1.875rem] flex flex-col items-center relative z-[2]">
        <H2 weight="bold" className="mb-[1.875rem]">
          {t('Revenue Details')}
        </H2>
        <Tabs initActiveTab="1">
          <TabsNavigation
            className="mx-4 !w-[calc(100%_-_2rem)] backdrop-blur-lg mb-3"
            list={tierList}
          />
          <Tab tabId="1" className="flex-1">
            <RevenueTierDatail level={1} />
          </Tab>
          <Tab tabId="2" className="flex-1">
            <RevenueTierDatail level={2} />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export { RevenueDetailsModal };
